module.exports = __webpack_public_path__ + "img/delete.63d25f9a.svg";